export type Honorific = 'mr' | 'ms';
export type PackIcon = 'dancer' | 'heart';

export const DANCER_EMOJI = {
  mr: '🕺',
  ms: '💃',
} as const;

export function dancerEmoji(honorific?: Honorific | null): string {
  if (honorific === 'ms') return DANCER_EMOJI.ms;
  if (honorific === 'mr') return DANCER_EMOJI.mr;
  return DANCER_EMOJI.mr;
}

export function greetingEmoji(honorific?: Honorific | null): string {
  return dancerEmoji(honorific);
}

export function titledName(
  name: string,
  honorific: Honorific | null | undefined,
  labels: { mr: string; ms: string },
): string {
  if (honorific === 'mr') return `${labels.mr} ${name}`;
  if (honorific === 'ms') return `${labels.ms} ${name}`;
  return name;
}

export function packSlotEmoji(opts: {
  filled: boolean;
  honorific?: Honorific | null;
  packIcon?: PackIcon | null;
}): string {
  if (!opts.filled) return '○';
  if (opts.packIcon === 'heart') return '🩷';
  return dancerEmoji(opts.honorific);
}

export type PersonVisual = {
  _id?: string;
  id?: string;
  userId?: string;
  name: string;
  honorific?: Honorific | null;
  photoFileId?: string | null;
  photoUrl?: string | null;
};
